import { SVGProps } from "react"

export const CalendarIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg
		viewBox="0 0 121 120"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<ellipse cx="60.5" cy="95" rx="60" ry="12" fill="#DCE0E6" />
		<rect x="16.5" y="31" width="88" height="64" rx="6" fill="#F5F5F5" />
		<rect x="23.5" y="46" width="74" height="42" rx="3" fill="white" />
		<path
			d="M17 26C17 22.6863 19.6863 20 23 20H99C102.314 20 105 22.6863 105 26V40H17V26Z"
			fill="#DCE0E6"
		/>
		<rect x="36.5" y="14" width="8" height="18" rx="4" fill="#AEB8C2" />
		<rect x="76.5" y="14" width="8" height="18" rx="4" fill="#AEB8C2" />
	</svg>
)
